<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="locationAlias-input">Location Alias</label>
            <input class="form-control" formControlName="locationAlias" id="locationAlias-input"
                   placeholder="Location Alias"
                   type="text">
            <dp-field-error [formField]="form['locationAlias']"></dp-field-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="firstName-input">First Name</label>
            <input class="form-control" formControlName="firstName" id="firstName-input" placeholder="First Name"
                   type="text">
            <dp-field-error [formField]="form['firstName']"></dp-field-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="lastName-input">Last Name</label>
            <input class="form-control" formControlName="lastName" id="lastName-input" placeholder="Last Name"
                   type="text">
            <dp-field-error [formField]="form['lastName']"></dp-field-error>
          </div>
        </div>
      </div>
      <div class="mb-16px"></div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="tel-input">Phone Number</label><span class="required">*</span>
            <input class="form-control" formControlName="tel"
                   id="tel-input"
                   placeholder="Phone Number"
                   type="text">
            <dp-field-error [formField]="form['tel']"></dp-field-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="email-input">Email</label><span class="required">*</span>
            <input class="form-control" formControlName="email"
                   id="email-input"
                   placeholder="Email"
                   type="email">
            <dp-field-error [formField]="form['email']"></dp-field-error>
          </div>
        </div>
      </div>
      <div>
        <label>Address</label><span class="required">*</span>
      </div>
      <app-google-places-autocomplete [data]="addressData"></app-google-places-autocomplete>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button (click)="submitForm($event)" class="btn btn-dark button-large" type="submit">{{ buttonLabel }}</button>
</div>
